import React from 'react'
import { Text, Icon } from 'components'
import styles from './NoticeInformation.module.scss'

const NoticeInformation = ({ show = false }) =>
  show && (
    <span className={styles.noticeInformation}>
      <Icon type="money" size={32} />
      <Text bold color="lightTextColor">
        As condições de pagamento e honorários de terceiros podem ser
        consultados diretamente no Edital.
      </Text>
    </span>
  )

export default React.memo(NoticeInformation)
